import React from 'react';
import { IListItem } from '@nkr/models/index';
import { Col, FormControl, FormGroup, Panel, Row } from 'react-bootstrap';

interface IProps {
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    postalCode: string,
    contactPhone: string,
    email: string,
    dob: string,
    disableElements: boolean,
    stateList: IListItem[],
    onFieldChange: (name: string, value: string) => void
}

const ShipTo = (props: IProps) => {
    const handleFieldChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        props.onFieldChange(name, value);
    };

    const handlePhoneChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        let phone = value.replace(/\D/g, '');

        props.onFieldChange(name, phone);
    };

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>Where should we ship the kit?</Panel.Heading>
            <Panel.Body>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <label>First Name:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='firstName'
                                value={props.firstName}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <label>Last Name:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='lastName'
                                value={props.lastName}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <FormGroup>
                    <label>Address 1:<span style={{ color: 'red' }}>*</span></label>
                    <FormControl
                        name='address1'
                        value={props.address1}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>

                <FormGroup>
                    <label>Address 2:</label>
                    <FormControl
                        name='address2'
                        value={props.address2}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>

                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <label>City:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='city'
                                value={props.city}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label>State:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='state'
                                componentClass={'select'}
                                value={props.state}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            >
                                <option value={''}>- Select -</option>
                                {props.stateList.map(x =>
                                    <option value={x.abbreviation}>{x.abbreviation}</option>
                                )}
                            </FormControl>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <label>Postal Code:<span style={{ color: 'red' }}>*</span></label>
                            <FormControl
                                name='postalCode'
                                value={props.postalCode}
                                onChange={handleFieldChange}
                                disabled={props.disableElements}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <FormGroup>
                    <label>Contact Phone:<span style={{ color: 'red' }}>*</span></label>
                    <FormControl
                        name='contactPhone'
                        maxLength={10}
                        value={props.contactPhone}
                        onChange={handlePhoneChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>

                <FormGroup>
                    <label>Email:<span style={{ color: 'red' }}>*</span></label>
                    <FormControl
                        name='email'
                        type='email'
                        value={props.email}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>

                <FormGroup>
                    <label>DOB:<span style={{ color: 'red' }}>*</span></label>
                    <FormControl
                        name='dob'
                        type='date'
                        value={props.dob}
                        onChange={handleFieldChange}
                        disabled={props.disableElements}
                    />
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default ShipTo;